module.exports = " <div class=user_panel _v-16f5ce7b=\"\"> <div class=user_info v-link=\"{ name: routerName }\" _v-16f5ce7b=\"\"> <avatar :src=avatar :username=username :rounded=true _v-16f5ce7b=\"\"></avatar> <span class=username _v-16f5ce7b=\"\">{{ username }}</span> </div> <menu _v-16f5ce7b=\"\"></menu> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-16f5ce7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/UserPanel.vue
 ** module id = 336
 ** module chunks = 2
 **/